import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const opts = {
  theme: {
    light: false,
    dark: true,
    themes: {
      light: {
        background: '#242A33',
        background2: '#394F71',
        textcolor:'#FFFFFF',
        textblack:'#000000',
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        confirm: {
          darken1: '#C9FFF2',
          lighten1: '#23303B',
          lighten2: '#00B8D9'
        },
        waiting: {
          darken1: '#E8EBFF',
          lighten1: '#2A2B3C',
          lighten2: '#6F5ECE'
        },
        notsend: {
          darken1: '#E9F4FB',
          lighten1: '#2A2C35',
          lighten2: '#8895AA'
        },
        tabletd: '#303134',
        'detail-title': {
          darken1: '#00B8D9',
          lighten1: '#23303B',
        },
        'proc-comm': {
          darken1: '#2A8C72',
        },
        'proc-envel': {
          darken1: '#155527',
        },
        'proc-filter': {
          darken1: '#443D76',
        },
        'proc-folder': {
          darken1: '#898C30',
        },
        'proc-mapper': {
          darken1: '#8B2B30',
        },
        'proc-converter': {
          darken1: '#1A5263',
        },
        'proc-set': {
          darken1: '#4E2931',
        },
        'proc': {
          darken1: '#F0F7FB'
        },
        textcolor1: '#1C0E59',
        textcolor2: '#0082BA',
        textcolor3: '#919699',
        textcolor4: '#7D838D',
        textcolor5: '#4C4F5A',
        bgleft: '#FAFCFF',
        bgright: '#FAFCFF',
        bgright2: '#EDF3FC',
        textIconAddUser: "#364B5F",
        'manager-col-modify':{
          darken1 : '#0082BA',
        },
        'manager-col-copy':{
          darken1 : '#9AAAC3',
        },
        'manager-col-delete':{
          darken1 : '#F14856',
        },
        'popup-col-delete':{
          darken1 : '#F14856',
        },
        'checkbox-col-lock':{
          darken1 : '#000000',
        },
        'checkbox-col-unlock':{
          darken1 : '#6E6F73',
        },
        'manager-col-preview':{
          darken1 : '#0082BA',
        },
        'manager-col-down':{
          darken1 : '#109E51',
        },
        'icon-add':{
          darken1 : '#0082BA',
        },
        'title-file-name':'#BA0070',
      },
      dark: {
        topheader:'#242A33',
        textcolor:'#b71c1c',
        textwhite:'#FFFFFF',
        background: "#8c9eff",
        primary: '#3f51b5',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#b71c1c',
        bgleft: '#3b3e49',
        bgright: '#FAFCFF',
        bgright2: '#232329',
        textIconAddUser: "#ffeb3b",
        textcolor4: '#D8D8D8',
        textcolor5: '#DFE1E5',
        confirm: {
          darken1: '#23303B',
          lighten1: '#00B8D9',
          lighten2: '#00B8D9',
        },
        waiting: {
          darken1: '#2A2B3C',
          lighten1: '#6F5ECE',
          lighten2: '#6F5ECE',
        },
        notsend: {
          darken1: '#2A2C35',
          lighten1: '#8895AA',
          lighten2: '#8895AA',
        },
        'detail-title': {
          darken1: '#23303B',
          lighten1: '#00B8D9',
        },
        'proc-comm': {
          darken1: '#2A8C72',
        },
        'proc-envel': {
          darken1: '#155527',
        },
        'proc-filter': {
          darken1: '#443D76',
        },
        'proc-folder': {
          darken1: '#898C30',
        },
        'proc-mapper': {
          darken1: '#8B2B30',
        },
        'proc-converter': {
          darken1: '#1A5263',
        },
        'proc-set': {
          darken1: '#4E2931',
        },
        'manager-col-modify':{
          darken1 : '#0082BA',
        },
        'manager-col-copy':{
          darken1 : '#DFE1E5',
        },
        'manager-col-delete':{
          darken1 : '#EB1E50',
        },
        'popup-col-delete':{
          darken1 : '#EB1E50',
        },
        'checkbox-col-lock':{
          darken1 : '#FFFFFF',
        },
        'checkbox-col-unlock':{
          darken1 : '#C4C4C4',
        },
        'manager-col-preview':{
          darken1 : '#0082BA',
        },
        'manager-col-down':{
          darken1 : '#30F2BD',
        },
        'icon-add':{
          darken1 : '#0082BA',
        },
        'proc': {
          darken1: '#191A21'
        },
        'title-file-name':'#F99DD4',
      },
      options: {
        customProperties: true,
      },
    },
  },
  /* icons: {
    iconfont: 'fa4', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  }, */
};

export default new Vuetify(opts);
